module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-text', [_c('v-container', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "loading": _vm.loading,
      "append-icon": _vm.checkMailValue.status === null ? '' : (_vm.checkMailValue.status ? 'check' : 'close'),
      "hint": !_vm.checkMailValue.status ? _vm.checkMailValue.message : '',
      "persistent-hint": "",
      "label": "Mail",
      "id": "email",
      "type": "email",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": function($event) {
        return _vm.checkMail()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Passwort",
      "hint": "Das Passwort muss mindestens 6 Zeichen lang sein.",
      "id": "password",
      "type": "password",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "confirmPassword",
      "label": "Passwort bestätigen",
      "id": "confirmPassword",
      "type": "password",
      "rules": [_vm.comparePasswords],
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.confirmPassword),
      callback: function($$v) {
        _vm.confirmPassword = $$v
      },
      expression: "confirmPassword"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "disabled": !this.password || (this.comparePasswords === 'Passwörter stimmen nicht überein') || this.comparePasswords || (this.checkMailValue.status === false) || (this.checkMailValue.status === null),
      "loading": _vm.loadingBtn
    },
    on: {
      "click": function($event) {
        return _vm.onSignup()
      }
    }
  }, [_vm._v("\n          Registrieren\n        ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [_c('v-btn', {
    staticClass: "caption",
    attrs: {
      "block": "",
      "text": "",
      "to": "/anmelden"
    },
    on: {
      "click": function($event) {
        return _vm.onDismissed()
      }
    }
  }, [_vm._v("\n          Anmelden\n        ")])], 1), _vm._v(" "), (_vm.errorMessage) ? _c('v-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12",
      "sm": "10",
      "offset-sm": "1"
    }
  }, [(_vm.errorMessage.code === 'keinBbr') ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n          Die Mailadresse gehört zu keinem Bundesbruder. Bitte kontrollier die eingegebene Adresse oder kontaktiere den Schriftführer.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage.code === 'auth/email-already-in-use') ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n          Es existiert bereits ein Account mit dieser E-Mailadresse. Bitte melde dich an oder setze dein Passwort zurück.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.errorMessage.code === 'auth/weak_password') ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n          Das Passwort muss mindestens 6 Zeichen lang sein.\n        ")]) : _vm._e(), _vm._v(" "), ((_vm.errorMessage.code !== 'keinBbr') && (_vm.errorMessage.code !== 'auth/email-already-in-use') && (_vm.errorMessage.code !== 'auth/weak_password')) ? _c('v-alert', {
    staticClass: "warning",
    attrs: {
      "dismissible": ""
    },
    on: {
      "dismissed": _vm.onDismissed
    }
  }, [_vm._v("\n          Bei der Registrierung ist ein Fehler aufgetreten. Fehlercode: " + _vm._s(_vm.errorMessage.code) + " | " + _vm._s(_vm.errorMessage.message) + "\n        ")]) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54027540"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/SignupForm.vue
// module id = 780
// module chunks = 15